import { render, staticRenderFns } from "./Manuals.vue?vue&type=template&id=c5604392&scoped=true&"
import script from "./Manuals.vue?vue&type=script&lang=js&"
export * from "./Manuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5604392",
  null
  
)

export default component.exports